module.exports = __webpack_public_path__ + "static/media/foto1.2dbbf7da.JPG";